import { dateToKey } from 'segments/utils/helpers/dateToKey';

import { CourtsBooking } from '../store/types';

export const convertCourtsBookingsToTable = (courts: CourtsBooking) => courts.map((court) => ({
  ...court,
  key: dateToKey(court.startTime),
}));
